import { memo } from 'react';

import {
  ScrollElementContextConsumer,
  ScrollElementContextProvider,
} from '~/components/v2/components/shared/scroll/ScrollElementContextProvider';
import { SearchSubSideNavItem } from '~/components/v2/components/workspace/search-nav/item/SearchSubSideNavItem';
import { SearchSubSideNav } from '~/components/v2/components/workspace/search-nav/SearchSubSideNav';
import { FAVORITED_ASSETS_NAV_ITEM } from '~/components/v2/components/workspace/search-nav/searchNavItems';
import { SubSideNavScrollbar } from '~/components/v2/components/workspace/sub-side-nav/SubSideNavScrollbar';
import { WorkspaceSidebarFavoriteBoards } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarFavoriteBoards';
import { WorkspaceSidebarLibraries } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarLibraries';
import { WorkspaceSidebarSectionStoreContextProvider } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarSectionStoreContext';
import { WorkspaceSidebarWorkspaceBoards } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarWorkspaceBoards';
import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';
import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';

export const LibrariesSubSideNav = memo(() => {
  const { libraries } = usePrivateAddOnFeatures();

  return (
    <ScrollElementContextProvider>
      <div className="flex h-full min-h-0 grow flex-col" data-testid="LIBRARIES_SUB_SIDE_NAV">
        <SearchSubSideNav />
        <ScrollElementContextConsumer>
          {({ setScrollElement }) => (
            <SubSideNavScrollbar onScrollElement={setScrollElement}>
              <WorkspaceSidebarSectionStoreContextProvider
                storageKey={ZustandStorageKeys.WorkspaceSidebarSectionFavoriteBoards}
              >
                <WorkspaceSidebarFavoriteBoards
                  leadingItems={<SearchSubSideNavItem item={FAVORITED_ASSETS_NAV_ITEM} />}
                />
              </WorkspaceSidebarSectionStoreContextProvider>
              {libraries ? (
                <WorkspaceSidebarSectionStoreContextProvider
                  storageKey={ZustandStorageKeys.WorkspaceSidebarSectionLibraries}
                >
                  <WorkspaceSidebarLibraries />
                </WorkspaceSidebarSectionStoreContextProvider>
              ) : (
                <WorkspaceSidebarSectionStoreContextProvider
                  storageKey={ZustandStorageKeys.WorkspaceSidebarSectionWorkspaceBoards}
                >
                  <WorkspaceSidebarWorkspaceBoards />
                </WorkspaceSidebarSectionStoreContextProvider>
              )}
            </SubSideNavScrollbar>
          )}
        </ScrollElementContextConsumer>
      </div>
    </ScrollElementContextProvider>
  );
});

LibrariesSubSideNav.displayName = 'LibrariesSubSideNav';
